import Phaser from 'phaser';
export { GROUND_Y, PLAYER_SPEED, GRAVITY_Y, JUMP_SPEED, QUESTION_BLOCK, COIN_JUMP_START_X, BLOCK_JUMP_START_X } from './level';

export const GAME_WIDTH = 390;
export const GAME_HEIGHT = 844;
export const WORLD_WIDTH = 1800;
import { GRAVITY_Y } from './level';

export const gameConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'app',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  pixelArt: true,
  backgroundColor: '#2b9de8',
  physics: { default: 'arcade', arcade: { gravity: { x: 0, y: GRAVITY_Y }, debug: false } },
  scale: { mode: Phaser.Scale.FIT, autoCenter: Phaser.Scale.CENTER_BOTH },
  render: { antialias: false, roundPixels: true }
};
